import { Constants } from "appConstants";
import LocalStorageHelper from "helpers/LocalStorageHelper";
import { useState } from "react";
import useStabilizedState from "./useStabilizedState";

export interface PaginationTools {
	page: number;
	stablePage: number;
	setPage: (newPage: number) => void;
	pageCount: number;
	setPageCount: (newPage: number) => void;
	pageItemCount: number;
	setPageItemCount: (newPageItemCount: number) => void;
}

export default function usePagination(
	storageKey: string,
	initialPage?: number
): PaginationTools {
	const [pageItemCount, setPageItemCount] =
		LocalStorageHelper.useLocalStorageState<number>(storageKey);

	const [pageCount, setPageCount] = useState<number>(
		Constants.INITIAL_PAGE_INDEX
	);

	const {
		setValue: setPage,
		unstableValue: page,
		stableValue: stablePage
	} = useStabilizedState<number>(
		initialPage ?? Constants.INITIAL_PAGE_INDEX,
		750
	);

	return {
		page,
		stablePage,
		setPage,
		pageCount,
		setPageCount,
		pageItemCount: pageItemCount ?? 10,
		setPageItemCount
	};
}
